export default __webpack_public_path__ + "static/apys@2x-7e9f2d43219ade64c23f9c3b55bdf6c8.png";